/*
 * @Author: Ryan
 * @Date: 2026-01-19
 * @Description: CTA section - Ready to Create Your First Product Avatar Video
 */
import React from 'react';

import StartButton from './StartButton';

const CTASection: React.FC = () => {
  return (
    <section className="w-full bg-[#0A0A0A] py-[80px] pad:py-[100px] sm:py-[120px] px-4 pad:px-8 sm:px-[65px]">
      <div className="max-w-[1190px] mx-auto text-center">
        {/* Title */}
        <h2 className="text-2xl pad:text-3xl sm:text-[42px] font-bold text-white mb-4 pad:mb-6 leading-tight">
          Turn Your Product Into a High‑Converting Video Now
        </h2>

        {/* Description */}
        <p className="text-sm pad:text-base sm:text-base text-gray-400 max-w-4xl mx-auto mb-8 pad:mb-10 sm:mb-12 leading-relaxed">
          Transform product photos into clear, engaging showcase videos using AI product
          avatars. Generate ecommerce‑ready videos in minutes and stay ahead in every
          marketplace.
        </p>

        {/* CTA Button */}
        <StartButton text="Create Your Product Avatar" />
      </div>
    </section>
  );
};

export default CTASection;
